module.exports = __webpack_public_path__ + "media/gallery.e7900992.mp4";